export const basketballKey = 'כדורסל'
export const nbaKey = 'NBA'
export const israeliTeamKey = 'כדורגל ישראלי'
export const worldTeamKey = 'כדורגל עולמי'
